<template>
<div>
    <div class="bk-gray-dark bk-gray-dark-margin">
        <div class="logo-secret">
            <img src="../../assets/images/image-secretele-laptelui/prebiotic.png" style="width: 38px; height: 42px">
        </div>
        <h3>Au efect prebiotic</h3>
        <p>Oligozaharidele din laptele matern stimulează creșterea și activitatea bacteriilor bune din burtică. O floră intestinală echilibrată ajută la dezvoltarea unei imunități puternice.</p>
    </div>
</div>
</template>

<script>
export default {
    components: {},
    data() {
        return {}
    },
}
</script>
<style scoped lang="scss">

</style>
